const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M2.01 21L23 12L2.01 3L2 10l15 2l-15 2z\"/>"
};
export default data;
